import { cn } from "@/lib/utils";

// Amden platform logo — icon + wordmark. Used as the default (unbranded) system logo.
export function AmdenLogo({ className = "h-9", dark = false }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <img src="/amden-logo.webp" alt="Amden" className={cn("object-contain", className)} data-testid="amden-logo-img" />
      <span className={cn("font-heading font-black tracking-tight text-2xl leading-none", dark ? "text-white" : "text-slate-900")}>Amden Pulse</span>
    </span>
  );
}
